<template>
  <v-dialog v-model="open" width="650px">
    <v-card dense>
      <v-toolbar elevation="0">
        <v-toolbar-title
          class="text--subtitle primary--text"
          style="padding-left: 10px"
        >
          <v-icon color="primary" style="padding-bottom: 2px"
            >mdi-crown-circle</v-icon
          >
          {{ $t('message.pages.AbTest.AbTest') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="handleCloseWinnerModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="px-7 py-0">
        <v-row no-gutters>
          <v-col cols="12">
            <span
              v-html="
                $t('message.pages.AbTest.chooseWinnerMessage', {
                  title: videoToWinTitle,
                })
              "
            ></span>
            <br />
          </v-col>
          <v-col cols="12" class="my-3">
            <b>{{ $t('message.pages.AbTest.chooseWinnerAdvice') }}</b>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="confirmText"
              dense
              outlined
              autofocus
              @keyup.enter="handleSetWinner"
              :placeholder="$t('message.confirm').toUpperCase()"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-7 pb-6">
        <v-spacer></v-spacer>
        <v-btn class="mr-4" text @click="handleCloseWinnerModal">
          {{ $t('message.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="handleSetWinner"
          class="white--text"
          :loading="isFinishing"
          :disabled="!confirmVerification || isFinishing"
        >
          <span class="px-5">{{ $t('message.confirm') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeclareTestWinner',
  props: {
    videoToWinTitle: {
      type: String,
      required: true,
    },
    isFinishing: {
      type: Boolean,
      required: true,
      default: false,
    },
    openDeclareWinner: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({
    confirmText: '',
  }),
  watch: {
    openDeclareWinner(value) {
      if (!value) this.confirmText = ''
    },
  },
  computed: {
    confirmVerification() {
      return (
        this.confirmText.toUpperCase() ===
        this.$i18next.t('message.confirm').toUpperCase()
      )
    },
    open: {
      get() {
        return this.openDeclareWinner
      },
      set(value) {
        if (!value) this.$emit('close')
      },
    },
  },
  methods: {
    handleSetWinner() {
      if (this.confirmVerification) this.$emit('handleSetWinner')
    },
    handleCloseWinnerModal() {
      this.$emit('close')
    },
  },
}
</script>
